import React from "react";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  heading: {
    color: "#ff4717",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  theadingstyles: {
    background: "rgb(26 26 49)",
    padding: "12px",
    borderTopRightRadius: "10px",
    borderTopLeftRadius: "10px",
    color: "white",
    fontSize: "16px",
  },
  active:{
     color: "#ff4717 !important",
    cursor:"pointer"

  },
  inactive:{
    cursor:"pointer"
  },
  shiplist: {
    "&.Mui-selected .MuiListItemText-root span": {
      color: "#ff4717 !important",
    },
  },

}));

export default function TrendsList(props) {
  const classes = useStyles();
  const { shipList, selectedShip, selectedShipChip } = props;
 
  const shipSelectedId = (row) =>{
    let shipArray = selectedShip;
    let shipKeyIndex = shipArray.indexOf(row);
    if(shipKeyIndex == -1){
      shipArray.push(row);
    }else{
      shipArray.splice(shipKeyIndex, 1);
    }
    selectedShipChip(shipArray);
  }

  return (
    <div>
      <Grid container fluid="md" spacing={3}>
        <Grid item xs={12}>
          <Typography
            variant="h5"
            align="left"
            className={clsx(classes.heading, classes.theadingstyles) + " bai-font"}
          >
            Ship List
          </Typography>
          <Paper
            className={classes.paper + " scrollBar"}
            style={{ height: "420px", overflow: "auto" }}
          >
          <listStyled component="nav" className="scroll-list">
            {shipList.length
              ? shipList.map((row, index) => {
                const indexShips = selectedShip.indexOf(row);
                  return(
                    <ListItem  textAlign="left"
                      className={clsx(classes.shiplist, "shiplist", indexShips > -1 ? classes.active : classes.inactive)}
                      button
                      onClick={(e) => {
                        shipSelectedId(row)
                      }}
                      selected={indexShips > -1 ? true : false}
                    >
                      <ListItemText>{row.shipName}</ListItemText>
                    </ListItem>
                  )
                })
              : "No data found"}     
            </listStyled>
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
